<template>
  <div class="w-full flex justify-center" :aria-label="ariaLabel">
    <div class="w-full bg-primary-subdued p-12 text-s font-regular text-grey-body">
      <template v-if="adminMessageData">
        <div class="block w-full text-center">
          <MessageBubbleAdminSeeker v-if="accountType === 'parent'" :data="adminMessageData" />
          <MessageBubbleAdminProvider v-else :data="adminMessageData" />
        </div>
      </template>
      <span v-else class="block w-full text-center text-s font-regular text-grey-body">{{ body }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { AdminMessageData } from '@/apps/messages/helpers/adminMessageFormatter';
import MessageBubbleAdminSeeker from './MessageBubbleAdminSeeker.vue';
import MessageBubbleAdminProvider from './MessageBubbleAdminProvider.vue';

export default {
  name: 'MessageBubbleAdmin',
  components: {
    MessageBubbleAdminSeeker,
    MessageBubbleAdminProvider,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    adminMessageData: {
      type: Object as PropType<AdminMessageData | null>,
      default: null,
    },
    accountType: {
      type: String as PropType<'parent' | 'sitter'>,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
};
</script>
